<template>
  <v-dialog
      v-model="dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                v-model="scheduler.name"
                :label="$t('common:name')"
                :rules="[
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.buffer"
                :label="$t('settings/settings:scheduler.buffer')"
                :rules="[
                  ruleIsEmptyOrNumberText($t('utils:rules.only-number')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.slots"
                :label="$t('settings/settings:scheduler.slots')"
                :rules="[
                  ruleIsEmptyOrInteger($t('utils:rules.onlynumerictext')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.budgetPriority"
                :label="$t('settings/settings:scheduler.budget-priority')"
                :rules="[
                  ruleIsEmptyOrNumberText($t('utils:rules.only-number')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                v-model="scheduler.diversityPriorty"
                :label="$t('settings/settings:scheduler.diversity-priority')"
                :rules="[
                  ruleIsEmptyOrNumberText($t('utils:rules.only-number')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.mutationsInnerLoop"
                :label="$t('settings/settings:scheduler.inner-mutations')"
                :rules="[
                  ruleIsEmptyOrInteger($t('utils:rules.onlynumerictext')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.mutationsOuterLoop"
                :label="$t('settings/settings:scheduler.kick-mutations')"
                :rules="[
                  ruleIsEmptyOrInteger($t('utils:rules.onlynumerictext')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.innerGenerations"
                :label="$t('settings/settings:scheduler.inner-generations')"
                :rules="[
                  ruleIsEmptyOrInteger($t('utils:rules.onlynumerictext')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-text-field
                outlined
                v-model="scheduler.outerGenerations"
                :label="$t('settings/settings:scheduler.outer-generations')"
                :rules="[
                  ruleIsEmptyOrInteger($t('utils:rules.onlynumerictext')),
                  ruleRequired($t('utils:rules.required')),
                ]"
              />

              <v-checkbox
                  v-model="scheduler.active"
                  :label="$t('common:active')"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card
                  elevation="0"
                  flat
                  tile
                  class="pl-3 pt-3 pb-md-3"
              >
                <TwoButtonDialog
                    ref="saveButton"
                    :btn-text="$t('buttons:save')"
                    color="primary"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:scheduler.scheduler') })"
                    :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:scheduler.scheduler') })"
                    :button1-text="$t('buttons:save')"
                    :button2-text="$t('buttons:cancel')"
                    @clickedButton1="updateForm()"
                    @clickedButton2="$refs.saveButton.showDialog = false"
                />
                <DirtyConfirmButtonDialog
                    ref="dirtyDialog"
                    :btn-text="$t('buttons:back')"
                    color="grey"
                    :hideOverlay="true"
                    :dialog-title="$t('dialog:save-btn-title')"
                    :dialog-text="$t('dialog:save-btn-dialog')"
                    :button1-text="$t('dialog:dirty-save-btn-1-text')"
                    :button2-text="$t('dialog:dirty-save-btn-2-text')"
                    @clickedButton="dialog=false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import {ruleRequired, ruleIsEmptyOrInteger, ruleIsEmptyOrNumberText} from '@/modules/core/services/rules';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import SchedulerService from '@/modules/settings/services/scheduler-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "SchedulerExternalForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  data() {
    return {
      scheduler: {},
      dialog: false,
      edit: false
    }
  },
  methods: {
    ruleRequired,
    ruleIsEmptyOrInteger,
    ruleIsEmptyOrNumberText,

    updateForm() {

      if (!this.$refs.form.validate()) {
        this.$refs.saveButton.showDialog = false;
        window.scrollTo(0, 0);
        return;
      }

      this.dialog = false;
      SchedulerService.saveScheduler(
          this.scheduler,
          () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:scheduler.scheduler')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:scheduler.scheduler')}));
            }

            this.$emit('updateTable');
          },
          () => {
            if (!this.edit) {
              Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:scheduler.scheduler')}));
            } else {
              Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:scheduler.scheduler')}));
            }
          }
      )
    },
    initialization(item) {
      this.scheduler = {};
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.scheduler = item;
        this.edit = true;
      }

      this.dialog = true;
    }
  }
}
</script>
